export default __webpack_public_path__ + "static/media/icon_mobilePostpaid.d69a13be.svg";